<template>
  <div class="gallery">
    <div class="container">
      <div class="heading" data-aos="fade-right">
        <h2 class="title font-secondary mb-3 fs-40 text-teal-dark text-center">
          Gallery
        </h2>
      </div>
      <!-- <div class="row justify-content-center">
        <div class="col-12 col-md-6 col-lg-6">
          <iframe
            width="100%"
            class="mb-4"
            height="275"
            src="https://www.youtube.com/embed/O8dFQbWTokA"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div> -->
      <div class="row justify-content-center">
        <div
          class=""
          v-for="(images, index) in gallery"
          :data-key="index"
          :data-count="images.items.length - 1"
          :key="index"
          :class="images.className"
        >
          <div class="flex-wrap row d-flex justify-content-center">
            <div
              class=""
              v-for="(image, imageIndex) in images.items"
              :key="imageIndex"
              :class="image.class"
            >
              <div class="elevation" :data-aos="image.transition">
                <div class="gallery-item" @click="showPopup(image)">
                  <!-- <v-lazy-image :src=""/> -->
                  <img :src="`${image.th || image.full}&tr=w-600`" />
                  <div class="hover-content">
                    <i class="material-icons">zoom_in</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row justify-content-center d-md-flex d-none"> -->
      <!-- <div class="col-md-12 col-lg-10 col-xl-8"> -->
      <!-- <iframe width="100%" height="400" src="https://www.youtube.com/embed/rTU7Zv1OiUw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
      <!-- </div> -->
      <!-- </div> -->
    </div>

    <transition name="fade">
      <div class="popup" v-if="preview">
        <div class="popup-wrapper">
          <div class="popup-tools">
            <button class="popup-close" @click="closePopup">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="popup-controls">
            <div class="left control" @click="prev">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="right control" @click="next">
              <i class="material-icons">chevron_right</i>
            </div>
          </div>
          <div class="popup-body">
            <img :src="preview.full" class="img-fluid" />
            <div class="copyright" v-if="preview.copyright">
              <i class="material-icons">camera_alt</i> Taken by
              <a :href="preview.copyright.link || null">{{
                preview.copyright.name
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      slickOpt: {
        slideToShow: 1
      },
      gallery: [
        {
          className: "col-md-12",
          items: [
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS04171.jpg?updatedAt=1774066811253",
              transition: "fade-down-right",
              class: "col-6 col-md-4"
            },
            {
              full:
                'https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS04084.jpg?updatedAt=1774067492270',
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-2"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS05037%20copy.jpg?updatedAt=1774066811241",
              transition: "fade-down-right",
              class: "col-12 col-md-4"
            },

            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS03952%20copy.jpg?updatedAt=1774066811171",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS04527.jpg?updatedAt=1774066811254",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },

            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS04200.jpg?updatedAt=1774066811183",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS04308.jpg?updatedAt=1774066811223",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS04044.jpg?updatedAt=1774066811178",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },
            //-------
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/KYR07630-Retouch%20by%20Kiyura.jpg?updatedAt=1774066810931",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/KYR07561-Retouch%20by%20Kiyura.jpg?updatedAt=1774066810849",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/KYR07553-Retouch%20by%20Kiyura.jpg?updatedAt=1774066810870",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/KYR07636-Retouch%20by%20Kiyura.jpg?updatedAt=1774066810957",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/KYR07647-Retouch%20by%20Kiyura.jpg?updatedAt=1774066810985",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },
            //----
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS04735%20copy.jpg?updatedAt=1774066811088",
              transition: "fade-down-right",
              class: "col-12 col-md-4 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS04979%20copy.jpg?updatedAt=1774066810949",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS04624%20copy.jpg?updatedAt=1774066811032",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS04503.jpg?updatedAt=1774066811217",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },
            {
              full:
                "https://ik.imagekit.io/ceremonyku/tanaya-reni/LFS04510%20copy.jpg?updatedAt=1774066811196",
              transition: "fade-down-right",
              class: "col-6 col-md-4 order-md-3"
            },
          ]
        }
      ],
      preview: null
    };
  },
  mounted() {
    document.addEventListener("keydown", e => {
      if (this.preview) {
        if (e.key === "ArrowRight") {
          this.next();
        }
        if (e.key === "ArrowLeft") {
          this.prev();
        }
        if (e.key === "Escape") {
          this.closePopup();
        }
      }
    });
  },
  methods: {
    showPopup(image) {
      this.preview = image;
    },
    closePopup() {
      this.preview = null;
    },
    next() {
      this.preview = this.nextImage;
    },
    prev() {
      this.preview = this.prevImage;
    }
  },
  computed: {
    images() {
      const images = [];

      this.gallery.forEach(items => {
        images.push(...items.items);
      });

      return images;
    },
    currentIndex() {
      return this.preview.full
        ? this.images.map(item => item.full).indexOf(this.preview.full)
        : null;
    },
    nextImage() {
      let index = this.currentIndex + 1;
      if (index > this.images.length - 1) {
        index = 0;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    },
    prevImage() {
      let index = this.currentIndex - 1;
      if (index < 0) {
        index = this.images.length - 1;
      }
      return this.currentIndex !== null ? this.images[index] : null;
    }
  },
  watch: {
    preview() {
      if (this.preview === null) {
        document.querySelector("body").style.overflowY = null;
      } else {
        document.querySelector("body").style.overflowY = "hidden";
      }
    }
  }
};
</script>

<style type="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
